(() => {
  console.log("[share-cart] loaded");

  const WORKER_URL = "https://eterlove-share-cart.tuoliangyueqiu.workers.dev";

  function getShopifyRoot() {
    const root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";

    return root.endsWith("/") ? root : `${root}/`;
  }

  async function getCart() {
    const root = getShopifyRoot();

    const res = await fetch(`${root}cart.js`, {
      method: "GET",
      credentials: "same-origin",
      cache: "no-store",
      headers: {
        Accept: "application/json"
      }
    });

    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`Failed to fetch cart: ${res.status} ${text.slice(0, 120)}`);
    }

    return res.json();
  }

  async function saveCart(cart) {
    const res = await fetch(`${WORKER_URL}/save`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        items: cart.items || []
      })
    });

    const data = await res.json();

    if (!res.ok || !data.success || !data.token) {
      throw new Error(data.error || "Failed to save cart");
    }

    return data.token;
  }

  function buildShareUrl(token) {
    return `${window.location.origin}/pages/cart-share?token=${encodeURIComponent(token)}`;
  }

  async function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }

    const input = document.createElement("textarea");
    input.value = text;
    input.setAttribute("readonly", "");
    input.style.position = "fixed";
    input.style.opacity = "0";
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
  }

  function showShareModal(url) {
    let modal = document.querySelector("[data-share-cart-modal]");

    if (!modal) {
      modal = document.createElement("div");
      modal.setAttribute("data-share-cart-modal", "");
      modal.className = "share-cart-modal";

      modal.innerHTML = `
        <div class="share-cart-modal__overlay" data-share-cart-close></div>
        <div class="share-cart-modal__dialog" role="dialog" aria-modal="true" aria-label="Share your cart">
          <button class="share-cart-modal__close" type="button" data-share-cart-close aria-label="Close">×</button>
          <h2 class="share-cart-modal__title">Share your cart</h2>
          <p class="share-cart-modal__text">The link is valid for 30 days.</p>
          <input class="share-cart-modal__input" type="text" readonly>
          <button class="share-cart-modal__copy" type="button">Copy Link</button>
          <p class="share-cart-modal__status" aria-live="polite"></p>
        </div>
      `;

      document.body.appendChild(modal);

      modal.addEventListener("click", async (event) => {
        if (event.target.matches("[data-share-cart-close]")) {
          modal.classList.remove("is-visible");
        }

        if (event.target.matches(".share-cart-modal__copy")) {
          const input = modal.querySelector(".share-cart-modal__input");
          const status = modal.querySelector(".share-cart-modal__status");

          try {
            await copyToClipboard(input.value);
            status.textContent = "Copied.";
          } catch (error) {
            status.textContent = "Copy failed. Please copy the link manually.";
          }
        }
      });
    }

    modal.querySelector(".share-cart-modal__input").value = url;
    modal.querySelector(".share-cart-modal__status").textContent = "";
    modal.classList.add("is-visible");
  }

  async function handleShareClick(event, button) {
    event.preventDefault();
    event.stopPropagation();

    const originalHtml = button.innerHTML;

    try {
      button.disabled = true;
      button.textContent = "Sharing...";

      const cart = await getCart();

      if (!cart.items || cart.items.length === 0) {
        alert("Your cart is empty.");
        return;
      }

      const token = await saveCart(cart);
      const shareUrl = buildShareUrl(token);

      showShareModal(shareUrl);
    } catch (error) {
      console.error("[share-cart]", error);
      alert(`Unable to create a share link: ${error.message}`);
    } finally {
      button.disabled = false;
      button.innerHTML = originalHtml;
    }
  }

  async function restoreCartFromToken() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token || !window.location.pathname.includes("/pages/cart-share")) {
      return;
    }

    const status = document.querySelector("[data-cart-share-status]");

    if (status) {
      status.textContent = "Restoring your cart...";
    }

    try {
      const res = await fetch(`${WORKER_URL}/load?token=${encodeURIComponent(token)}`);
      const data = await res.json();

      if (!res.ok || !data.success || !data.cart || !Array.isArray(data.cart.items)) {
        throw new Error(data.error || "Invalid share cart token");
      }

      await fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });

      for (const item of data.cart.items) {
        const addRes = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: item.id,
            quantity: item.quantity || 1,
            properties: item.properties || {}
          })
        });

        if (!addRes.ok) {
          const text = await addRes.text().catch(() => "");
          throw new Error(`Failed to restore item ${item.id}: ${addRes.status} ${text.slice(0, 120)}`);
        }
      }

      window.location.href = "/cart";
    } catch (error) {
      console.error("[share-cart restore]", error);

      if (status) {
        status.textContent = "This shared cart link is invalid, expired, or contains unavailable items.";
      }
    }
  }

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-share-cart-button]");
    if (!button) return;

    console.log("[share-cart] button clicked");
    handleShareClick(event, button);
  });

  document.addEventListener("DOMContentLoaded", restoreCartFromToken);
})();